import styled from "styled-components";

export const TradeChartSectionWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;

  .widgetClose {
    display: none;
  }

  &:hover {
    .widgetClose {
      display: flex;
    }
  }
`;
